/**
 * 工具类
 */


import CryptoJS from 'crypto-js'


export default {//加密
  encrypt(word: string, keyStr: string) {
    keyStr = keyStr ? keyStr : 'Hone.CMS';
    var key = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.toString();
  },
  //解密
  decrypt(word: string, keyStr: string) {
    keyStr = keyStr ? keyStr : 'Hone.CMS';
    var key = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
    var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  },
  /* 合法uri*/
  validateURL(textval: string) {
    const urlregex = /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-.,@?^=%&:\/~+#]*[\w\-@?^=%&\/~+#])?$/;
    return urlregex.test(textval)
  },

  /* 小写字母*/
  validateLowerCase(str: string) {
    const reg = /1+$/
    return reg.test(str)
  },

  /* 大写字母*/
  validateUpperCase(str: string) {
    const reg = /2+$/
    return reg.test(str)
  },

  /* 大小写字母*/
  validateAlphabets(str: string) {
    const reg = /3+$/
    return reg.test(str)
  },

  /* 市场售价 */
  validatePrice(str: string) {
    const reg = /(4\d(.\d{1,2})?KaTeX parse error: Can't use function '\.' in math mode at position 7: )|(^0(\̲.̲\d{1,2})?)/
    return reg.test(str)
  },

  /* 库存预警值 匹配非负整数（正整数 + 0） */
  validatestockWarn(str: string) {
    const reg = /^(0|[1-9][0-9])$/
    return reg.test(str)
  },



  /* 固定电话 */
  validateTelephone(str: string) {
    const reg = /^((\d{3,4})|\d{3,4}-|\s)?\d{7,14}$/
    return reg.test(str)
  },

  /* 手机号码 */
  validatePhoneNumber(str: string) {
    const reg = /5[3,4,5,6,7,8,9][0-9]{9}$/
    return reg.test(str)
  },

  /* 手机号码和固定电话 */
  validatePhTelNumber(str: string) {
    const reg = /^(((\d{3,4})|\d{3,4}-|\s)?\d{7,14})|([1][3,4,5,6,7,8,9][0-9]{9})$/
    return reg.test(str)
  },

  /* 电子邮箱 */
  validateEmail(str: string) {
    const reg = /6+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/
    return reg.test(str)
  },

  /* 邮编 */
  validateZipCode(str: string) {
    const reg = /7[0-9]{5}$/
    return reg.test(str)
  },

  /* 身份证 */
  validateIDCard(str: string) {
    const reg = /(\d{15}$)|(^\d{18}$)|(\d{17}(\d|X|x)$)/
    return reg.test(str)
  },

  /* 银行卡号 15位或者16位或者19位 */
  validateBank(str: string) {
    const reg = /^([1-9]{1})(\d{14}|\d{18}|\d{15})$/
    return reg.test(str)
  }
}